import type { Cents } from '@fruitful/types';

import { requestBuilder } from '../../../../http/RequestBuilder';

// TODO jason
//   Move to shared package _after_ IM launch

export enum RetirementDistributionCreateType {
    TYPE_UNSPECIFIED = 'TYPE_UNSPECIFIED',
    NORMAL = 'NORMAL',
    DISABILITY = 'DISABILITY',
    SOSEPP = 'SOSEPP',
    PREMATURE = 'PREMATURE',
    DEATH = 'DEATH',
    EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE = 'EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE',
    EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE = 'EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE',
    ROLLOVER_TO_QUALIFIED_PLAN = 'ROLLOVER_TO_QUALIFIED_PLAN',
    ROLLOVER_TO_IRA = 'ROLLOVER_TO_IRA',
    DISTRIBUTION_TRANSFER = 'DISTRIBUTION_TRANSFER',
    RECHARACTERIZATION_PRIOR_YEAR = 'RECHARACTERIZATION_PRIOR_YEAR',
    RECHARACTERIZATION_CURRENT_YEAR = 'RECHARACTERIZATION_CURRENT_YEAR',
    DISTRIBUTION_CONVERSION = 'DISTRIBUTION_CONVERSION',
    MANAGEMENT_FEE = 'MANAGEMENT_FEE',
    PLAN_LOAN_401K = 'PLAN_LOAN_401K',
    PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS = 'PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS',
    NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS = 'NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS',
    NET_INCOME_ATTRIBUTABLE = 'NET_INCOME_ATTRIBUTABLE',
    REVOCATION = 'REVOCATION',
    NON_REPORTABLE = 'NON_REPORTABLE',
}

export const ReadableRetirementContributionType: Record<
    RetirementDistributionCreateType,
    string
> = {
    DEATH: '',
    DISABILITY: '',
    DISTRIBUTION_CONVERSION: '',
    DISTRIBUTION_TRANSFER: '',
    EXCESS_CONTRIBUTION_REMOVAL_AFTER_TAX_DEADLINE:
        'Excess contribution removal after tax deadline',
    EXCESS_CONTRIBUTION_REMOVAL_BEFORE_TAX_DEADLINE:
        'Excess contribution removal before tax deadline',
    MANAGEMENT_FEE: '',
    NET_INCOME_ATTRIBUTABLE: '',
    NON_REPORTABLE: '',
    NORMAL: '',
    NORMAL_ROTH_IRA_GREATER_THAN_5_YEARS: '',
    PLAN_LOAN_401K: '',
    PREMATURE: 'Premature distribution',
    PREMATURE_SIMPLE_IRA_LESS_THAN_2_YEARS: '',
    RECHARACTERIZATION_CURRENT_YEAR: '',
    RECHARACTERIZATION_PRIOR_YEAR: '',
    REVOCATION: '',
    ROLLOVER_TO_IRA: '',
    ROLLOVER_TO_QUALIFIED_PLAN: '',
    SOSEPP: '',
    TYPE_UNSPECIFIED: 'Other',
};
export interface TaxWithholding {
    amountCents?: number;
    percentage?: number;
}

export interface RetirementDistribution {
    type: RetirementDistributionCreateType;
    federalTaxWithholding?: TaxWithholding;
    stateTaxWithholding?: TaxWithholding;
    stateWithholdingWaiver?: boolean;
}

export interface TestICTWithdrawalRequest {
    userId?: string;
    fromApexAccountId: string;
    toSyncteraAccountId: string;
    /**
     * The amount to withdraw in cents.
     * Required when fullDisbursement is false or undefined.
     * Must not be provided when fullDisbursement is true.
     */
    amountCents?: Cents;
    memo?: string;
    /**
     * Whether the entire account balance is being withdrawn.
     * If true, the amountCents field must not be provided.
     * If false or undefined, the amountCents field is required.
     */
    fullDisbursement?: boolean;
    /**
     * Retirement distribution details.
     * Required for retirement accounts (IRA, Roth IRA, SEP IRA, Rollover IRA).
     * Must not be provided for non-retirement accounts.
     */
    retirementDistribution?: RetirementDistribution;
}

export interface TestICTWithdrawalResponse {
    /** Whether the workflow completed within the initial wait period */
    completed: boolean;
    /** The workflow ID for tracking */
    workflowId: string;
    /** The idempotency key / client transfer ID */
    idempotencyKey: string;
    /** Expected settlement date from the trading calendar (YYYY-MM-DD) */
    expectedSettlementDate?: string;
    /** Current state of the ICT transfer (e.g., 'PROCESSING', 'POSTED', 'REJECTED', 'PENDING_WEBHOOK', 'WORKFLOW_ERROR') */
    state: string;
    /** Human-readable summary of state metadata for debugging (e.g., "REJECTED by Sentinel2: The transfer was not approved. Reasons: AmountAvailable-...") */
    stateMessage?: string;
    /** Error information if the workflow failed before reaching webhook wait */
    workflowError?: {
        message: string;
        name?: string;
        failedStep?: string;
    };
}

const useTestICTWithdrawal = requestBuilder.mutation<
    TestICTWithdrawalResponse,
    TestICTWithdrawalRequest
>({
    endpoint: '/api/admin/ict/withdrawal',
    method: 'POST',
});

export default useTestICTWithdrawal;
